import { ApplicationConfig, provideZoneChangeDetection, isDevMode, provideAppInitializer, inject, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFa from '@angular/common/locales/fa';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from '@core/interceptors/http.interceptor';
import { timezoneInterceptor } from '@core/interceptors/timezone.interceptor';
import { authInitializer } from '@core/initializers/auth.initializer.util';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { MENU_ITEMS } from './layout/utils/menu.token';
import { MENU } from './layout/constants/MENU';
import { USER_PROFILE } from './core/tokens/user-profile.tokens';
import { UserProfileStore } from './core/state/user-profile.store';
import { ProfileAutoLoaderService } from './core/services/profile-auto-loader.service';
import { MODAL_OVERLAY_DEFAULT_CONFIG } from '@ui/domain/modal-overlay-config';
import { ModalOverlayConfig } from '@ui/domain/modal-overlay-model';

import { OverlayModule } from '@angular/cdk/overlay';
import { BOTTOM_SHEET_DEFAULT_CONFIG } from '@ui/domain/bottom-sheet.config';
import { BottomSheetConfig } from '@ui/domain/bottom-sheet.mode';
import { PROFILE_MENU_ITEMS } from './layout/utils/profile-menu.token';
import { PROFILE_MENU } from './layout/constants/PROFILE-MENU';
import { KycStatusStore } from './core/state/kyc-status.store';
import { KYC_PUBLIC, KYC_STATUS } from './core/tokens/kyc-status.tokens';
import { KycStatusAutoLoaderService } from './core/services/kyc-status-auto-loader.service';
import { registerSvgAssets } from './app-svg-assets.initializer';

registerLocaleData(localeFa, 'fa-IR');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fa-IR' },
    provideHttpClient(withFetch(), withInterceptors([timezoneInterceptor, errorInterceptor, authInterceptor])),
    provideAppInitializer(() => authInitializer()),
    provideAppInitializer(() => registerSvgAssets()),
    provideAppInitializer(() => {
      inject(ProfileAutoLoaderService);
      inject(KycStatusAutoLoaderService);
    }),
    { provide: USER_PROFILE, deps: [UserProfileStore], useFactory: (userProfileStore: UserProfileStore) => userProfileStore.profile },
    { provide: KYC_STATUS, deps: [KycStatusStore], useFactory: (s: KycStatusStore) => s.kyc },
    { provide: KYC_PUBLIC, deps: [KycStatusStore], useFactory: (s: KycStatusStore) => s.public },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:5000',
    }),
    provideClientHydration(withEventReplay()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'fixed', dir: 'rtl' } as MatFormFieldDefaultOptions,
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['app-snackbar', 'app-mt-100'],
      } as MatSnackBarConfig,
    },
    {
      provide: MODAL_OVERLAY_DEFAULT_CONFIG,
      useValue: {
        hasBackdrop: true,
        disableClose: false,
        borderRadius: '20px',
      } as ModalOverlayConfig,
    },
    provideRouter(routes),
    { provide: MENU_ITEMS, useValue: MENU },
    { provide: PROFILE_MENU_ITEMS, useValue: PROFILE_MENU },
    importProvidersFrom(OverlayModule),
    {
      provide: BOTTOM_SHEET_DEFAULT_CONFIG,
      useValue: {
        hasBackdrop: true,
        disableClose: false,
        borderRadius: '20px',
      } as BottomSheetConfig,
    },
  ],
};
